import React from "react";
import HomePage from "../../../HomePage";
import "./index.css";
import image from "../../../../Assets/signupImage.png";
import icon from "../../../../Assets/icon2.png";
import choose_lang from "../../../../Assets/choose_lang.png";

interface ISidePanelProps {
  className?: string;
  type: string;
}

const LoginSignupSidePanel: React.FC<ISidePanelProps> = ({
  className,
  type,
}) => {
  return (
    <div className={`${className} typoGraphySection`}>
      {type === "login" ? (
        <HomePage />
      ) : (
        <div className="homePageRoot homePageSecondaryBackground">
          {type === "signup" ? (
            <img className="signup" src={image} alt="SignUp" />
          ) : type === "linkAccount" ? (
            <img className="width40" src={icon} alt="INK" />
          ) : type === "languageSelection" ? (
            <img className="width50" src={choose_lang} alt="Choose Language" />
          ) : (
            <></>
          )}
        </div>
      )}
    </div>
  );
};

export default LoginSignupSidePanel;
